<template>
  <div
    @click="logDynamicData"
  class="flex items-stretch" :id="`three-banner-layout-${random_id}`">
    <div class="items-stretch grow">
        <Blocks
            class="w-full"
            :parent="props.builderBlock?.id"
            :path="`component.options.leftBlocks`"
            :blocks="props.leftBlocks"
        />
    </div>
    <div class="min-w-[350px]">

        <Blocks
            class="w-full"
            :parent="props.builderBlock?.id"
            :path="`component.options.rightTopBlocks`"
            :blocks="props.rightTopBlocks"
        />

        <Blocks
            class="w-full"
            :parent="props.builderBlock?.id"
            :path="`component.options.rightBottomBlocks`"
            :blocks="props.rightBottomBlocks"
        />

    </div>
  </div>
</template>

<script setup lang="ts">
import { Blocks } from '@builder.io/sdk-vue';

type Props = {
  builderBlock?: object;
  leftBlocks?: any;
  rightTopBlocks?: any[];
  rightBottomBlocks?: any[];
}

const props = defineProps<Props>();

const random_id = ref('')

onMounted(() => {
  random_id.value = useRandomUUID()
})
// GTM Log FOR banner click
const logDynamicData = () => {
  bannerClick(props, "banner layout")
};
</script>
